import { type ButtonBaseProps } from '@mui/material';
import StyledImagePreviewThumbnail from './ImagePreviewThumbnail/StyledImagePreviewThumbnail';
import { VisibilityOff as ImageHiddenIcon } from '@mui/icons-material';

type NoImagePreviewThumbnailProps = Omit<
  ButtonBaseProps,
  'children' | 'tabIndex'
> & {
  showInappropriateContentIndicators: boolean;
};

const NoImagePreviewThumbnail = ({
  showInappropriateContentIndicators,
  ...props
}: NoImagePreviewThumbnailProps) => (
  <StyledImagePreviewThumbnail
    src={null}
    containsInappropriateContent={showInappropriateContentIndicators}
    tabIndex={-1}
    {...props}
  >
    <ImageHiddenIcon />
  </StyledImagePreviewThumbnail>
);

export default NoImagePreviewThumbnail;
